import React from 'react';
import SubscritpionsListView from "../views/SubscriptionListing";
import { confirmAlert } from 'react-confirm-alert'; // Import
import Subscriptions from "./Subscription"
import $ from 'jquery';
const get_token = localStorage.getItem("token");
let save_subscibe = localStorage.getItem("SaveSubscription");
const inpersonateFlag = localStorage.getItem("inpersonate");
class SubscriptionsListing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      table: {
        data: [],
        loading: true,
        totalRows: 0,
        perPage: 1,
      },
      pagechange: 1,
      addSubscriptionFlag: false,
      listSubscriptionFlag: false,
      subscriptionTitle: '',
      issucessMEssage: false,
      issubscribeLoader: false,
      errorstatuscode: '',

    };
  }
  componentDidMount() {
    if (save_subscibe != 1) {
      this.setState({ listSubscriptionFlag: true })
    }
    const requestOptions = {
      method: "GET",
      mode: "cors",
      headers: {
        'Authorization': 'Bearer' + get_token,
      },
    };

    fetch(`./wp-json/asd/api/subscriptions`, requestOptions)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        else if (response.status === 401 || response.status === 403) {
          this.setState({ issucessMEssage: "You have been logged out, please login again", errorstatuscode: '' });
          localStorage.removeItem("token");
          window.location.href = "/asd-login";
        } else if (response.status === 404) {
          this.setState({ issucessMEssage: "There are no subscriptions to display.", issubscribeLoader: false, errorstatuscode: '404' });
          return false
        } else if (response.status === 500) {
          this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", errorstatuscode: '' });
          return false
        } else {
          this.setState({ issucessMEssage: "Something went's wrong. Please try again later", errorstatuscode: '' });
        }
      })
      .then(userData => {
        if (userData.data != null) {
          this.setState({
            table: {
              data: userData.data,
              loading: false,
              totalRows: userData.total_records
            },
            errorstatuscode: ''
          });
        }
      })

  }

  handleSubscribe = () => {
    const inpersonateUser = localStorage.getItem("inpersonate_user") ? localStorage.getItem("inpersonate_user") : '';
    if (inpersonateFlag === 'true') {
      confirmAlert({
        message: 'Are you sure want to add Subscription for Partner?',
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              this.setState({ addSubscriptionFlag: true, listSubscriptionFlag: false });
            }
          },
          {
            label: 'No',
            onClick: () => {
              return false;
            }
          }
        ]
      });
    }
    else {
      this.setState({ addSubscriptionFlag: true, listSubscriptionFlag: false });
    }

    localStorage.removeItem('subscribeedit_id');
  }
  SubscribeList = () => {
    this.setState({ addSubscriptionFlag: false, listSubscriptionFlag: true });
    save_subscibe = localStorage.setItem("SaveSubscription", 0);
  }
  render() {
    const handlePageChange = async page => {
      const get_token = localStorage.getItem("token");
      this.setState({ pagechange: page, issubscribeLoader: true })
      const reportRequestOptions = {
        method: 'GET',
        mode: "cors",
        headers: {
          'Authorization': 'Bearer' + get_token,
        },

      }
      fetch(`./wp-json/asd/api/subscriptions?page_no=` + page, reportRequestOptions)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          else if (response.status === 401 || response.status === 403) {
            this.setState({ issucessMEssage: "You have been logged out, please login again", issubscribeLoader: false, errorstatuscode: '' });
            localStorage.removeItem("token");
            window.location.href = "/asd-login";
          } else if (response.status === 404) {
            this.setState({ issucessMEssage: "There are no subscriptions to display.", issubscribeLoader: false, errorstatuscode: '404' });
            return false
          } else if (response.status === 500) {
            this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", issubscribeLoader: false, errorstatuscode: '' });
            return false
          } else {
            this.setState({ issucessMEssage: "Something went's wrong. Please try again later", issubscribeLoader: false, errorstatuscode: '' });
          }
        })
        .then(userData => {
          if (userData.data != null) {
            this.setState({
              table: {
                data: userData.data,
                loading: false,
                totalRows: userData.total_records
              },
              issubscribeLoader: false,
              errorstatuscode: ''
            });
          }
        })

    }
    const handleDeleteSubscription = (event, newValue) => {
      const user_id = event.currentTarget.id;
      confirmAlert({
        title: 'Confirm to delete',
        message: 'Are you sure you want to delete Subscription?',
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              const requestOptions = {
                method: "DELETE",
                mode: "cors",
                headers: {
                  'Authorization': 'Bearer' + get_token,
                },
              };
              if (user_id !== '') {
                fetch(`./wp-json/asd/api/subscriptions/` + user_id, requestOptions)
                  .then(response => response.json())
                  .then(userData => {
                    window.location.href = './myaccount';
                  });
              }
            }
          },
          {
            label: 'No',
            onClick: () => {
              return false;
            }
          }
        ]
      });
    };
    const handleEditList = (event, newValue) => {
      const user_id = event.currentTarget.id;
      if (inpersonateFlag === 'true') {
        confirmAlert({
          message: 'Are you sure you want to Edit Subscription for Partner?',
          buttons: [
            {
              label: 'Yes',
              onClick: () => {
                if (user_id !== '') {
                  localStorage.setItem('subscribeedit_id', user_id);
                  this.setState({ addSubscriptionFlag: true, listSubscriptionFlag: false });
                }
                else {
                  localStorage.removeItem('subscribeedit_id');
                }
              }
            },
            {
              label: 'No',
              onClick: () => {
                return false;
              }
            }
          ]
        });
      }
      else {
        if (user_id !== '') {
          localStorage.setItem('subscribeedit_id', user_id);
          this.setState({ addSubscriptionFlag: true, listSubscriptionFlag: false });
        }
        else {
          localStorage.removeItem('subscribeedit_id');
        }
      }
    };
    let InpersonateButton;
    const inpersonateUser = localStorage.getItem("inpersonate_user") ? localStorage.getItem("inpersonate_user") : '';
    //const inpersonateUserId = localStorage.getItem("inpersonate_id") ? localStorage.getItem("inpersonate_id") : '';
    if (inpersonateFlag === 'true') {
      InpersonateButton = () => {
        return (
          ''
          // <div className="inpersonate-user-section">
          //   <button onClick={handleBacktoLoginUser} className="back-btn bg-orange hover:bg-gray-100 text-gray-800 font-semibold border border-gray-400 rounded shadow text-white" data-impersonation="false" id="2">
          //     <svg className="MuiSvgIcon-root jss67 back-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true" tabIndex="-1" title="ArrowBackIos" data-ga-event-category="material-icons" data-ga-event-action="click" data-ga-event-label="ArrowBackIos"><path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path></svg>
          //     <span className="inpersonate-name">Back to regular user</span>
          //   </button>
          //   <span className="user-btn markdown-body reset text-gray-800 font-semibold border border-gray-400 rounded shadow">
          //     <svg className="MuiSvgIcon-root jss373 person" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation" tabIndex="-1" title="People"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"></path></svg>
          //     <span className="name">{inpersonateUser}</span></span>
          // </div>


        );
      }
    } else {
      InpersonateButton = () => {
        return ""
      }
    }

    const handleBacktoLoginUser = (event, newValue) => {
      if (event.currentTarget.attributes.getNamedItem('data-impersonation').value === "true") {
        localStorage.setItem('inpersonate', true);
      } else {
        localStorage.setItem('inpersonate', false);
      }
      const get_token = localStorage.getItem("token");
      const user_id = localStorage.getItem("userId");
      const requestOptions = {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({ get_token: get_token, user_id: user_id })
      };
      if (event.currentTarget.id != '') {

        fetch(`./wp-json/asd/users/inpersonate`, requestOptions)
          .then(response => response.json())
          .then(userData => {
            if (
              "jwt_auth_invalid_token" === userData.code ||
              "jwt_auth_bad_iss" === userData.code
            ) {
              localStorage.removeItem("token");
              window.location.href = "/asd-login";
            } else if ("jwt_auth_bad_request" === userData.code) {
              if (userData.message) {
                alert(userData.message);
              }
            } else if (userData != null) {
              if (userData.token != null) {
                localStorage.setItem('token', userData.token);
                window.location.href = './';
              }
            }
          });
      }
    };

    return (
      <div>
        <div className="subscription-list-wrap">
          <span>You will manage your subscription for reports.</span>
          <div className="pt-6 mt-3 float-right inpersonate-user"><InpersonateButton /></div>
          <div className="subscription-wrap-blk">
            <div className="main-title">
              <span>MANAGE SUBSCRIPTION</span>
              {this.state.listSubscriptionFlag ? <button className="subscribe-btn float-right" onClick={this.handleSubscribe}>Add Subscription</button> : ''}
              {(save_subscibe == 1) || this.state.addSubscriptionFlag ? <button className="subscribe-btn float-right" onClick={this.SubscribeList}>Back to Subscription Listing</button> : ''}
            </div>
            {(save_subscibe == 1) || this.state.addSubscriptionFlag ? <Subscriptions /> : ''}
            {this.state.listSubscriptionFlag ?
              <div>
                {this.state.issucessMEssage.length > 0 ? <div className="flex flex-center"><p className={this.state.errorstatuscode == "404" ? "subscribe-sent-msg no-subscribe" : "subscribe-sent-msg"}>{this.state.issucessMEssage}</p></div> : ''}
                {!this.state.issucessMEssage ?
                  <div className="flex-center">{this.state.issubscribeLoader ? <div className="list-download-loader"><div className="spinner"></div></div> : ''}
                    <SubscritpionsListView
                      userData={this.state.table.data}
                      pagechange={this.state.pagechange}
                      userLoading={this.state.table.loading}
                      userRows={this.state.table.totalRows}
                      handleDeleteSubscription={handleDeleteSubscription}
                      handleEditList={handleEditList}
                      handlePageChange={handlePageChange}

                    /></div> : ''}
              </div>

              : ''}
          </div>
        </div>
      </div>
    )
  }
}
export default SubscriptionsListing